module.exports = __webpack_public_path__ + "img/map-view-preview.e2389440.png";